export default function getBannerToRender({
  isLoggedIn,
  isVip,
  currentlySubscribed,
}) {
  const playerPlus = 'playerPlus'
  // VIP and P+ users see no banner
  if (isVip && currentlySubscribed) return null
  // logged out users see P+
  if (!isLoggedIn) return playerPlus
  // non P+ users see P+
  if (!currentlySubscribed) return playerPlus
  // P+ users that are not VIP see VIP
  if (currentlySubscribed && !isVip) return null

  return null
}
